import React from 'react';

import Icon, { IconProp } from '~components/icon';

import { TooltipPortal } from './index';

interface ComponentProps {
  id: string | number;
  icon: IconProp;
  tooltip?: string;
  iconColor?: string;
}

const TooltipIcon: React.FC<ComponentProps> = ({ id, icon, tooltip, iconColor }) => {
  const target = `tooltip-icon-${id}`;
  if (!tooltip) return <></>;
  return (
    <>
      <div className="d-flex justify-content-center" id={target}>
        <Icon icon={icon} color={iconColor} />
      </div>
      <TooltipPortal targetId={target} content={tooltip} />
    </>
  );
};

export default TooltipIcon;
